import {FC, ReactNode} from 'react';

import {matchPath, RouteProps} from 'react-router-dom';

import ROUTES from 'routes';

import AppRedirect from 'router/AppRedirect';
import AppRoute from 'router/AppRoute';
import {useAuth} from 'hooks/useAuth';
import {generateUrl} from "helpers/global";

interface RouteProviderProps extends RouteProps {
    path?: string;
    children?: ReactNode;
}

const RouteProvider: FC<RouteProviderProps> = ({path = '/', children, ...rest}) => {
    const {isAuthorized} = useAuth();
    return (
        <AppRoute
            path={path}
            {...rest}
            render={({location}) => {
                const route = Object.values(ROUTES).find(
                    (item) =>
                        !!matchPath(location.pathname, {
                            path: item.path,
                            exact: true,
                        }),
                );

                if (route === ROUTES.notificationViewer) {
                    const url = generateUrl(ROUTES.notificationViewerEmailLogs.path, {
                        region: 'us',
                        environment: 'dev'
                    })
                    return <AppRedirect
                        path="*"
                        to={{
                            pathname: url,
                        }}
                    />
                }
                if (!route) {
                    return (
                        <AppRedirect
                            path="*"
                            to={{
                                pathname: isAuthorized ? ROUTES.errorPage.path : ROUTES.login.path,
                            }}
                        />
                    );
                }

                return children;
            }}
        />
    )
};

export default RouteProvider;
